import { PrivilegeChecker } from 'omni-common-ui';
import is from 'is_js';
import TabSwitcher, { TabCodes } from 'domain/TabSwitcher';
import Privileges from 'domain/Privileges';
import SessionReport from './component';
import SessionNav from 'containers/Group/SessionNav';
import { isGrammarProGroup } from 'containers/Group/actions';
import ViewNav from 'components/ViewNav';
import { accessors as CIC } from 'data/CoveredInClass';
import { accessors as Feedback } from 'data/Feedback';
import StudentSelect from './StudentSelect';

const ROOT_PATH = 'session-report';
export const CATEGORY_FEEDBACK = 'feedback';
export const CATEGORY_GRAMMAR_PRO = 'grammar-pro';
export const Modes = {
  ADD_NOTES: 'add-notes',
  EDIT_NOTES: 'edit-notes',
  DELETE_NOTES: 'delete-notes',
  EXPORT: 'export',
  SAVE: 'save',
};

// add priveledge check later
const isAccessable = (state, groupId) =>
  TabSwitcher.isTabEnabled(state, groupId, TabCodes.SessionReport) &&
  PrivilegeChecker.hasPrivilege(state, Privileges.CoveredInClass.ViewCoveredInClass);

export default ({ getState }) => ({
  actionButtons: {
    default: {
      'Add Notes': {
        route: `./${Modes.ADD_NOTES}`,
        visibleWhen: ({ params }) =>
          params.category === CATEGORY_GRAMMAR_PRO &&
          PrivilegeChecker.hasPrivilege(getState(),
            Privileges.CoveredInClass.AddCommentToInternal),
      },
      Publish: {
        isPrimary: true,
        route: `./${Modes.SAVE}`,
        visibleWhen: ({ params }) => {
          const { groupId, sessionPlanId } = params;
          const isNotFuture = CIC.isNotFutureSession(getState(), { groupId, sessionPlanId });
          const hasSaved = CIC.hasSaved(getState(), params.sessionPlanId);
          return is.existy(hasSaved) &&
            ! hasSaved &&
            isNotFuture &&
            PrivilegeChecker.hasPrivilege(getState(),
              Privileges.CoveredInClass.MarkAndPublish);
        },
      },
      Export: {
        route: `./${Modes.EXPORT}`,
        visibleWhen: ({ params }) => {
          const { sessionPlanId, studentId } = params;
          const hasCICSaved = CIC.hasSaved(getState(), sessionPlanId);
          const hasFeedbackSaved = Feedback.hasFeedbackSaved(getState(), sessionPlanId, studentId);
          return hasCICSaved && hasFeedbackSaved;
        },
      },
    },
  },
  appBars: ({ params }) => {
    const { category } = params;
    return {
      sticky: Object.assign({
        'session-nav': {
          component: SessionNav,
          order: 1,
          props: {
            shouldShowTime: isGrammarProGroup(getState(), params.groupId),
          },
        },
        'view-nav': {
          component: ViewNav,
          order: 3,
        },
      }, category === CATEGORY_FEEDBACK ? {
        'student-select': {
          component: StudentSelect,
          order: 2,
        },
      } : {}),
    };
  },
  path: `${ROOT_PATH}(/session/:sessionPlanId)(/unit/:unitId)(/student/:studentId)(/category/:category)(/:mode)(/:index)`,
  component: SessionReport,
  breadcrumbLabels: (props) => {
    const { params: { groupId }, buildRoute } = props;
    return {
      label: 'session report',
      href: buildRoute(`/group/${groupId}/${ROOT_PATH}`),
    };
  },
  canAccess: ({ params: { groupId } }) => isAccessable(getState(), groupId),
  tab: {
    label: 'Session Report',
    // make this into a constant later
    order: 12,
    isVisible: ({ groupId }) => isAccessable(getState(), groupId),
  },
  secondLevelTabs: (props) => {
    const { location: { pathname }, buildRoute, push } = props;
    if (! pathname.includes(ROOT_PATH)) return [];
    return [
      {
        text: 'GRAMMAR PRO COVERED IN CLASS',
        onClick: () => push(buildRoute({ category: CATEGORY_GRAMMAR_PRO })),
      },
      {
        text: 'Feedback',
        onClick: () => push(buildRoute({ category: CATEGORY_FEEDBACK })),
      },
    ];
  },
});



// WEBPACK FOOTER //
// ./containers/Group/SessionReport/routes.js